module.exports = __webpack_public_path__ + "img/11.9e8d8859.png";